import { Link } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Breadcrumb from '../components/BreadCurmb';
import FooterOne from '../footer/FooterOne';
import HeaderOne from '../header/HeaderOne';

export default function Portfolio (){
	return(
		<>
			<HeaderOne/>
			<Breadcrumb title={"Portfolio"} subtitle={"Responsvie IT Solution & Portfolio"} pagetitle={"Portfolio"}/>
			<main>				
				<section className="portfolio-area pt-110 pb-90 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30">

					<div className="container">
						<div className="row justify-content-center">
						<Tabs>
							<TabList>
								<Tab>All Works</Tab>
								<Tab>Marketing</Tab>
								<Tab>IT Solution</Tab>
								<Tab>Website</Tab>
								<Tab>UI & UX</Tab>
								<Tab>Software</Tab>
							</TabList>

							<TabPanel>
								<div className="grid row align-items-center">
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3 cat4">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-4.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat1 cat2">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-5.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3 cat5">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-6.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat4">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-7.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat1 cat3">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-8.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2 cat3 cat5">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-9.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat14 cat4">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-10.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat5 cat4">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-11.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-12.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-13.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-14.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
									<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
										<div className="portfolio-wrapper2 mb-30">
											<img className="img-fluid" src="assets/img/portfolio/pr-15.jpg" alt="Portfolio Img" />
											<div className="portfolio-content">
												<p>Digital Marketing</p>
												<h3 className="portfolio-title text-white">Miranda Website Design</h3>
												<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
											</div>
										</div>
									</div>
								</div>
							</TabPanel>
							<TabPanel>
								<div className="grid row align-items-center">								
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2 cat3 cat5">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-9.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat14 cat4">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-10.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat5 cat4">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-11.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-12.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-13.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-14.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-15.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								</div>
							</TabPanel>
							<TabPanel>
								<div className="grid row align-items-center">
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3 cat4">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-4.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat1 cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-5.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3 cat5">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-6.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat4">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-7.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-12.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-13.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								
								</div>
							</TabPanel>
							<TabPanel>
								<div className="grid row align-items-center">
								
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-13.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-14.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-15.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								</div>
							</TabPanel>
							<TabPanel>
								<div className="grid row align-items-center">								
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat1 cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-5.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3 cat5">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-6.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat4">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-7.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-12.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-13.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-14.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-15.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								</div>
							</TabPanel>
							<TabPanel>
								<div className="grid row align-items-center">
								
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat4">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-7.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat1 cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-8.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2 cat3 cat5">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-9.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat14 cat4">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-10.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat5 cat4">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-11.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-12.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-13.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat2">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-14.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								<div className="col-lg-4 col-md-6 col-sm-6 grid-item cat3">
									<div className="portfolio-wrapper2 mb-30">
										<img className="img-fluid" src="assets/img/portfolio/pr-15.jpg" alt="Portfolio Img" />
										<div className="portfolio-content">
											<p>Digital Marketing</p>
											<h3 className="portfolio-title text-white">Miranda Website Design</h3>
											<Link className="fs-14 fw-bold text-white" to="/case-details">Portfolio Details </Link>
										</div>
									</div>
								</div>
								</div>
							</TabPanel>

						</Tabs>
						</div>
							
					</div>
				</section>
			</main>
			<FooterOne/>		
		</>
	
	)
}
  
